// extracted by mini-css-extract-plugin
module.exports = {"tag":"LabelTag_tag__3yEXm","date":"LabelTag_date__smulk"};